const communityBoardRouter = [
    {
        path: "list-community_board",
        name: "community_board_list",
        component: () => import("@/views/admin/community_board"),
        default: true,
        meta: {
            model: "community_board",
        },
    },
    {
        path: "list-community_board/edit/:id",
        name: "community_board_edit",
        component: () => import("@/views/admin/community_board/function"),
        default: true,
        meta: {
            model: "community_board",
        },
    },
    {
        path: "list-community_board/add",
        name: "community_board_add",
        component: () => import("@/views/admin/community_board/function"),
        default: true,
        meta: {
            model: "community_board",
        },
    },
];

export default communityBoardRouter;
